import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

import { TableData } from '../../../../../table-overlay/table-overlay';

@Component({
  selector: 'ct-extraction-table-overlay-confirm-button',
  imports: [TooltipModule],
  template: `
    <button
      [pTooltip]="
        shouldDisableConfirmButton()
          ? 'Bitte definiere den Inhalt von mindestens einer Spalte.'
          : ''
      "
      [disabled]="shouldDisableConfirmButton()"
      class="bg-primary disabled:bg-theme-gray-500 pointer-events-auto flex w-fit cursor-pointer items-center justify-center gap-1.5 rounded-md px-2 py-1 text-white shadow disabled:cursor-crosshair"
      (click)="buttonClicked.emit(); $event.stopPropagation()"
      (mouseup)="$event.stopPropagation()"
      (mousedown)="$event.preventDefault(); $event.stopPropagation()">
      <span class="material-icons flex h-fit! w-fit! text-sm">check_circle</span>
      <span class="block h-fit w-fit text-[0.6rem] uppercase">Bestätigen</span>
    </button>
  `,
  styles: `
    :host {
      margin-left: auto;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableOverlayConfirmButtonComponent {
  readonly tableData = input.required<TableData>();
  readonly buttonClicked = output();

  protected readonly shouldDisableConfirmButton = computed(
    () =>
      this.tableData()
        .columnHeaders()
        .every((label) => label === undefined) && this.tableData().layoutDefined(),
  );
}
